





















import { Component, Vue, namespace } from 'nuxt-property-decorator'
import { IStyle } from '~/assets/interfaces/classes'
import {
  ABOUT_PATH,
  CONTACTS_PATH,
  REQUISITES_PATH,
} from '~/assets/config/path'
import { filterUrl } from '~/assets/filters/url'
import ComponentImage from '~/components/images/image.vue'
import aboutImage from '~/assets/images/pages/company/about.jpg'
import requisitesImage from '~/assets/images/pages/company/requisites.jpg'
import contactsImage from '~/assets/images/pages/company/contacts.jpg'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
import { IMeta } from '~/assets/interfaces/meta'
interface IHelpItem {
  title: string
  url: string
  image: string
}
const pageStore = namespace('page')

@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentTypographyH1,
    ComponentImage,
  },
  filters: {
    filterUrl,
  },
})
export default class pageContactsIndex extends Vue {
  private items: IHelpItem[] = [
    {
      title: 'О магазине',
      url: ABOUT_PATH,
      image: aboutImage,
    },
    {
      title: 'Контакты',
      url: CONTACTS_PATH,
      image: contactsImage,
    },
    {
      title: 'Реквизиты',
      url: REQUISITES_PATH,
      image: requisitesImage,
    },
  ]

  private $style!: IStyle
  private styleGrid!: IStyle
  private styleMobileGrid!: IStyle
  private get classWrapper() {
    return {
      [this.$style.wrapper]: true,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }

  private get classPageWrapper() {
    return {
      [this.styleGrid.container]: !this.$device.isMobileOrTablet,
      [this.styleMobileGrid.container]: this.$device.isMobileOrTablet,
      [this.$style.pageWrapper]: true,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }

  @pageStore.Mutation('setMeta') private setMeta!: (
    meta: IMeta
  ) => Promise<void>

  private created(): void {
    this.setMeta({
      title: 'Компания',
      h1: 'Компания',
    })
  }
}
